// extracted by mini-css-extract-plugin
module.exports = {"header":"ModalInfo_header__1EHuy","footer":"ModalInfo_footer__1zTHw"};